// src/helpers/factories/settings/paymentsFactory.ts
var DUAL_PRICING_LIST_PRICE_OPTIONS = [
  "cash" /* CASH */,
  "card" /* CARD */
];
var paymentsDualPricingListPriceOptionsFactory = (t) => DUAL_PRICING_LIST_PRICE_OPTIONS.map((option, index) => ({
  label: t(
    `settingsModule.paymentsSettings.dualPricing.listPrice.options.${option}`
  ),
  value: index + 1
}));

export { DUAL_PRICING_LIST_PRICE_OPTIONS, paymentsDualPricingListPriceOptionsFactory };
